import type { LocaleId } from '../../../core/i18n/locale-id';
import type { AddressRetrieveDetail } from '../../../core/models/address-retrieve';

/**
 * Maps the active UI locale to Canada Post AddressComplete language codes.
 */
export function toAddressCompleteLanguageCode(locale: LocaleId): string {
  return locale === 'fr' ? 'FRE' : 'ENG';
}

/**
 * Picks the retrieve detail whose language matches the active page locale when multiple are returned.
 */
export function selectAddressRetrieveDetailForLocale(
  details: AddressRetrieveDetail[],
  locale: LocaleId,
): AddressRetrieveDetail | undefined {
  if (details.length === 0) {
    return undefined;
  }

  if (details.length === 1) {
    return details[0];
  }

  const targetLanguage = toAddressCompleteLanguageCode(locale);

  return (
    details.find((detail) => detail.language.trim().toUpperCase() === targetLanguage) ?? details[0]
  );
}
